import { useResolvedAccessLevel } from '../../components/PermissionsContainer';

/**
 * Component id for the order weight group — **Lbs / Kgs / Metric Tons**.
 *
 * NOT Tare Lbs, despite the name: on /pro the container wraps `WeightFieldsBody`
 * alone (OrderFormView), and Tare Lbs renders in the row after it on the ordinary
 * order-edit gate. The Change All / Search Results grid takes the wider reading —
 * `change_all_grid_fields.FIELD_COMPONENTS` maps `tarelbs` here too — so the grid
 * withholds a cell /pro leaves open. Over-restrictive, not broken, and left alone
 * deliberately; whichever way it is settled, settle both sides together.
 *
 * The fields were put behind their own container during the overweight-check rollout
 * so edit access could be withdrawn per group if it caused trouble; they ship
 * view-only until an admin grants it.
 */
export const ORDER_WEIGHT_FIELDS_COMPONENT_ID = 'order-weight-fields';

/**
 * Whether the current user may edit the order's weight fields.
 *
 * Ships **defaultDisabled**, matching the container on /pro — so the Search Results
 * grid withholds those cells for exactly the people the order form withholds them
 * from, rather than making a bulk edit the one way around the gate. (Tare Lbs is the
 * one field where the two sides disagree — see the component id's doc above.)
 *
 * Note this does NOT gate the IMPORT "Weight (Lbs) is required" save-block, which
 * applies to everyone; it only picks that block's wording ("contact the order's LC").
 * See useOrderEditing's `canEditWeightFields`.
 */
export const useCanEditOrderWeightFields = (): boolean =>
  useResolvedAccessLevel(ORDER_WEIGHT_FIELDS_COMPONENT_ID, false, true) >= 2;
